import { render, staticRenderFns } from "./summaryAssessment.component.vue?vue&type=template&id=1aa4c84c&scoped=true&"
import script from "./summaryAssessment.component.vue?vue&type=script&lang=js&"
export * from "./summaryAssessment.component.vue?vue&type=script&lang=js&"
import style0 from "./summaryAssessment.component.vue?vue&type=style&index=0&id=1aa4c84c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa4c84c",
  null
  
)

export default component.exports